<template>
  <slider-tournament />

  <the-nav />

  <div class="main-wrap">
    <div class="tt-tabs tournaments-tabs">
      <div class="index-tabs">
        <span
          @click="this.tabActive = 0"
          :class="this.tabActive === 0 ? 'active-ttab' : ''"
          v-if="tournamentsActive.length > 0"
          >Активные</span
        >
        <span @click="this.tabActive = 1" :class="this.tabActive === 1 ? 'active-ttab' : ''">Запланированные</span>
        <span @click="this.tabActive = 2" :class="this.tabActive === 2 ? 'active-ttab' : ''">Завершенные</span>
      </div>

      <div class="index-panel">
        <div v-if="this.tabActive === 0" class="tt-panel">
          <template v-if="tournamentsActive.length > 0">
            <template v-for="(tournament, index) in tournaments" :key="tournament.id">
              <template v-if="tournament.status === 'active'">
                <winners-block v-if="index === 2" />
                <tournament-block :tournament="tournament" />
              </template>
            </template>
          </template>
          <div class="empty-tournament" v-else>Нет активных турниров</div>
        </div>

        <div v-if="this.tabActive === 1" class="tt-panel">
          <template v-if="tournaments?.find(elem => elem.status === 'scheduled')">
            <template v-for="(tournament, index) in tournaments" :key="tournament.id">
              <template v-if="tournament.status === 'scheduled'">
                <winners-block v-if="index === 2" />
                <tournament-block :tournament="tournament" />
              </template>
            </template>
          </template>
          <div class="empty-tournament" v-else>Нет запланированных турниров</div>
        </div>

        <div v-if="this.tabActive === 2" class="tt-panel">
          <template v-if="tournaments?.find(elem => elem.status === 'past')">
            <template v-for="(tournament, index) in [...tournaments].reverse()" :key="tournament.id">
              <template v-if="tournament.status === 'past'">
                <winners-block v-if="index === 2" />
                <tournament-block :tournament="tournament" />
              </template>
            </template>
          </template>
          <div class="empty-tournament" v-else>Нет завершенных турниров</div>
        </div>
      </div>
    </div>

    <slot-topics />

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import BonusesLine from '@/components/BonusesLine.vue'
import PlayLine from '@/components/PlayLine'
import TournamentBlock from '@/components/tournaments/TournamentBlock'
import TheNav from '@/components/TheNav'
import SliderTournament from '@/components/sliders/SliderTournament'
import SlotTopics from '@/components/SlotTopics'
import WinnersBlock from '@/components/Winners'
import { mapGetters } from 'vuex'
import { FETCH_TOURNAMENTS } from '@/store/actions.type'

export default {
  name: 'Tournaments',
  components: {
    TournamentBlock,
    WinnersBlock,
    PlayLine,
    SliderTournament,
    TheNav,
    BonusesLine,
    SlotTopics,
  },
  data() {
    return {
      tabActive: 0,
    }
  },
  computed: {
    ...mapGetters(['tournaments', 'tournamentsActive']),
  },
  mounted() {
    this.$store.dispatch(FETCH_TOURNAMENTS).then(() => {
      if (this.tournamentsActive.length === 0) {
        this.tabActive = 1
      }
    })
  },
  created() {
    if (this.$route.params.page === 'future') {
      this.tabActive = 1
    } else if (this.$route.params.page === 'past') {
      this.tabActive = 2
    } else {
      this.tabActive = 0
    }
  },
}
</script>

<style scoped>
.empty-tournament {
  text-align: center;
  margin: 60px 0;
}
</style>
